import { FormField } from 'ui/formField';
import { BasicSelect } from 'ui/selects';
import { useHyperlinkFormContext } from '../../contexts/hyperlinkForm';
import { useTranslation } from '../../../../../../../hooks/useTranslation';
import { LinkTarget } from '../../types';

export const TargetSelect = () => {
  const { t } = useTranslation();
  const { register, setValue, getValues } = useHyperlinkFormContext();

  return (
    <FormField labelText={t('contentPicker.textEditor.target')}>
      <BasicSelect
        id="link-target"
        defaultValues={[getValues().target]}
        onSelect={([newTarget]) => setValue('target', newTarget)}
        hideWhenDetached={false}
        data-test="target-select"
        options={[
          {
            id: LinkTarget.NewWindow,
            value: LinkTarget.NewWindow,
            label: t('contentPicker.textEditor.targetBlank'),
          },
          {
            id: LinkTarget.SameWindow,
            value: LinkTarget.SameWindow,
            label: t('contentPicker.textEditor.targetSelf'),
          },
        ]}
        {...register('target', { required: true })}
      />
    </FormField>
  );
};
